<template>
  <div
    :style="`position: relative;min-height: ${Height};background:${Color};`"
    class="sectionImg"
  >
    <img :src="imgbc2" :style="Styleleft" class="img" alt="triangle1">
    <img :src="imgbc2" :style="Styleright" class="img" alt="triangle2">
    <div class="SectionCon content-container">
      <div :style="`min-height: ${Height};color: white;`" class="txtcon">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import imgbc from "@/assets/Triangle/Fill 5.png";
import imgbc2 from "@/assets/Triangle/test.png";

export default {
  props: {
    color: {
      type: String,
      default: "#3A43D8"
    },
    height: {
      type: String,
      default: "530px"
    },
    styleleft: {
      type: String,
      default: "bottom: 7%;left: 5%;"
    },
    styleright: {
      type: String,
      default: "top: 2%;right: 3%;"
    }
  },
  data() {
    return {
      imgbc,
      imgbc2
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.sectionImg {
  padding-bottom: 40px;
  .SectionCon {
    margin: 0 auto;
    margin-top: 64px;
  }
}
img {
  position: absolute;
  // z-index: 3;
}

.txtcon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
